/*
 * ****************************************************************
 * File: keyboard.js
 * Project: CPaaS
 * Owner: Radisys
 *
 * Copyright - 2021 Radisys Corporation.
 * All rights reserved. No part of this software may be used or
 * reproduced in any form by any means without the prior written
 * permission of Radisys Corporation.
 *
 * Author: Pavan Kumar
 *
 * ****************************************************************
 */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import {
  Button,
  IconButton,
  InputAdornment,
  Popover,
  TextField,
  Typography,
} from "@material-ui/core";
import { Backspace, Close } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
  buttonrow: {
    flexDirection: "row",
    width: "260px",
  },
  buttoncenter: {
    justifyContent: "center",
    flexDirection: "row",
    display: "flex",
  },
  divStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  dialpadTypography: {
    margin: "0.6rem",
    fontSize: "18px",
    padding: "5px",
  },
  buttonStyle: {
    borderRadius: "0px",
    margin: "0.1rem",
    background: "#E6F7FF",
    minWidth: "23.5%",
    height: "45px",
    justifyContent: "center",
    padding: "3px",
    marginLeft: "2px",
  },
}));

const Keyboard = ({
  open,
  close,
  anchorEl,
  setusername,
  username,
  session,
}) => {
  const inputRef = React.useRef();
  const classes = useStyles();
  const calcBtns = [
    "1",
    "2",
    "3",
    "A",
    "4",
    "5",
    "6",
    "B",
    "7",
    "8",
    "9",
    "C",
    "*",
    "0",
    "#",
    "D",
  ];
  return (
    <div style={{ marginBottom: "20%" }}>
      <Popover
        style={{
          width: "485px",
          background: "transparent",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "right",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <div className={classes.divStyle}>
          <Typography data-testid="text" className={classes.dialpadTypography}>
            Dialpad
          </Typography>
          <IconButton
            data-testid="click"
            onClick={() => {
              close();
              setusername("");
            }}
            style={{ color: "red", float: "right" }}
          >
            <Close />
          </IconButton>
        </div>
        <div style={{ margin: "5px" }}>
          <TextField
            style={{ width: "245px" }}
            autoFocus
            variant="outlined"
            size="small"
            margin="none"
            fullWidth
            name="username"
            value={username}
            // onChange={(e) => setusername(username + e.target.value)}
            InputProps={{
              inputRef: inputRef,
              endAdornment: (
                <InputAdornment position="end">
                  {username !== "" ? (
                    <Backspace
                      data-testid="clear"
                      style={{
                        cursor: "pointer",
                        color: "black",
                        marginRight: "0.3rem",
                      }}
                      onClick={() => setusername(username.slice(0, -1))}
                    />
                  ) : (
                    <Backspace style={{ display: "none" }} />
                  )}
                </InputAdornment>
              ),
            }}
          />
        </div>

        <div className={classes.buttonrow}>
          {calcBtns.map((item, i) => {
            return (
              <Button
                data-testid={"button" + item}
                key={i}
                className={classes.buttonStyle}
                onClick={(e) => {
                  if (session.session) {
                    session.session.sendDTMF(item);
                    setusername(username + e.target.textContent);
                  }
                }}
                value={item}
              >
                {item}
              </Button>
            );
          })}
        </div>
      </Popover>
    </div>
  );
};

Keyboard.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  anchorEl: PropTypes.any,
  username: PropTypes.string.isRequired,
  setusername: PropTypes.func.isRequired,
  session: PropTypes.any,
};

export default Keyboard;
